import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";
import { useCart } from "./useCart";

export const useCartPageLoading = (): boolean => {
    const { isPendingOrderLoading } = useCart();
    const {
        isLoading: isTranslationsLoading,
        isFetching: isTranslationsFetching,
    } = useStringTranslation();
    const { isLoading: isUserLoading } = useGetUserInfoQuery();

    return (
        isPendingOrderLoading ||
        isTranslationsLoading ||
        isTranslationsFetching ||
        isUserLoading
    );
};
